/**
 * Validates a UK phone number in +44 format (for AWS Cognito).
 * @param {string} phoneNumber - The phone number to validate.
 * @returns {boolean} - True if valid, else false.
 */
const validateUKPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || phoneNumber.trim() === '') {
    return false;
  }

  // Remove all whitespace
  const cleanedPhone = phoneNumber.replace(/\s+/g, '');
  const cognitoUKPhoneRegex = /^\+44[1-9]\d{8,9}$/;

  if (!cognitoUKPhoneRegex.test(cleanedPhone)) {
    // console.error(
    //   'Enter a valid UK phone number starting with +44 (e.g., +447912345678)'
    // );
    return false;
  }

  return true;
};

export { validateUKPhoneNumber };
